const dateTime = new Intl.DateTimeFormat('ko-KR', {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
});

const timeOnly = new Intl.DateTimeFormat('ko-KR', {
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hour12: false,
});

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '-';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '-' : dateTime.format(d);
}

export function formatTime(iso: string | number | null | undefined): string {
  if (iso === null || iso === undefined) return '-';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '-' : timeOnly.format(d);
}

/** "3분 전", "2시간 전", or the date for anything older than a day. */
export function formatRelative(iso: string | null | undefined, now = Date.now()): string {
  if (!iso) return '-';
  const t = new Date(iso).getTime();
  if (Number.isNaN(t)) return '-';
  const diff = Math.max(0, now - t);
  const min = Math.floor(diff / 60_000);
  if (min < 1) return '방금 전';
  if (min < 60) return `${min}분 전`;
  const hours = Math.floor(min / 60);
  if (hours < 24) return `${hours}시간 전`;
  return formatDateTime(iso);
}

export function formatBytes(n: number): string {
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}

/**
 * Normalises what a customer types as an invite code: uppercase, unambiguous alphabet only,
 * dash after the 4th character, at most 8 characters. "k7px4mqz" -> "K7PX-4MQZ".
 */
export function formatInviteCode(input: string): string {
  const clean = input
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '')
    .slice(0, 8);
  return clean.length > 4 ? `${clean.slice(0, 4)}-${clean.slice(4)}` : clean;
}

export function isCompleteInviteCode(code: string): boolean {
  return /^[A-Z0-9]{4}-[A-Z0-9]{4}$/.test(code);
}

/** Hostname-ish label for a URL, used as a tab title fallback. */
export function shortUrl(url: string): string {
  if (!url || url === 'about:blank') return '새 탭';
  try {
    const u = new URL(url);
    return u.host + (u.pathname !== '/' ? u.pathname : '');
  } catch {
    return url;
  }
}
